const translation = {
  title: '存储集群',
  create: {
    title: '创建存储集群',
  },
  detail: {
    title: '存储集群详情',
  },
  edit: {
    title: '编辑存储集群',
  },
  list: {
    empty_text: '暂无数据',
  },
  // 表单字段
  form: {
    name: '名称',
    nameTooltip: '存储集群的唯一标识名称，创建后不可修改',
    regionName: '区域名称',
    regionNameTooltip: '存储集群所在的地域或可用区名称',
    type: '存储类型',
    typeTooltip: '存储集群的类型，如 CephFS、本地存储、LoongStore 等',
    path: '集群路径',
    pathTooltip: '集群在文件系统中的路径，例如：/',
    server: '集群地址',
    serverTooltip: '集群地址，例如：123.123.123.123:6789',
    userName: '用户名称',
    userNameTooltip: '用于连接存储集群的认证用户名',
    userKey: '用户密钥',
    userKeyTooltip: '用于连接存储集群的认证密钥，请妥善保管',
    apiHost: 'API地址',
    apiHostTooltip: 'API地址，例如：123.123.123.123:5000',
    apiUsername: 'API用户名',
    apiUsernameTooltip: '用于调用存储集群管理API的用户名',
    apiPassword: 'API用户密码',
    apiPasswordTooltip: '用于调用存储集群管理API的认证密码',
    fsId: '文件系统ID',
    fsIdTooltip: 'CephFS 文件系统的唯一标识ID，可通过 ceph fs ls 命令查看',
    confirm: '确定',
    cancel: '取消',
  },
  // 表格列标题
  table: {
    id: 'ID',
    regionName: '区域名称',
    server: '服务地址',
    userName: '用户名',
    userKey: '用户密钥',
    path: '路径',
    isDefault: '默认集群',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
  },
  // 操作按钮
  actions: {
    create: '创建存储集群',
    update: '更新存储集群',
    search: '搜索',
  },
  // 状态文本
  status: {
    yes: '是',
    no: '否',
  },
}

export default translation
